import { render, staticRenderFns } from "./deliveryChannelManagement.vue?vue&type=template&id=16a6e599"
import script from "./deliveryChannelManagement.vue?vue&type=script&lang=js"
export * from "./deliveryChannelManagement.vue?vue&type=script&lang=js"
import style0 from "./deliveryChannelManagement.vue?vue&type=style&index=0&id=16a6e599&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a6e599')) {
      api.createRecord('16a6e599', component.options)
    } else {
      api.reload('16a6e599', component.options)
    }
    module.hot.accept("./deliveryChannelManagement.vue?vue&type=template&id=16a6e599", function () {
      api.rerender('16a6e599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/deliveryChannelManagement.vue"
export default component.exports